import sharedModule from '../../shared.module';

class RedirectService {
    constructor(__env, $window) {
        this.__env = __env;
        this.$window = $window;
    }

    onError(type) {
        this.$window.location.href = `${this.__env.cloudUrl}/cs/#!/error/${type}`;
    }
}

export default sharedModule.service('redirectService', RedirectService);



// WEBPACK FOOTER //
// ./modules/shared/services/redirect/redirect.service.js